import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';
import { rgba } from 'polished';
// Gradients

export class GradientBg extends Mixin {
  style({$}, [$color]) {
    if ($.enableGradients) {
      return css`background: ${$color} linear-gradient(180deg, ${mix("15%", $.bodyBg, $color)}, ${$color}) repeat-x`;
    } else {
      return css`background-color: ${$color}`;
    }
  }
};

// Horizontal gradient, from left to right
//
// Creates two color stops, start and end, by specifying a color and position for each color stop.
export class GradientX extends Mixin {
  style({$}, [startColor=undefined, endColor=undefined, startPercent="0%", endPercent="100%"]) {
    startColor = startColor ?? $gray700;
    endColor = endColor ?? $gray800;
    return css`
      background-image: linear-gradient(to right, ${startColor} ${startPercent}, ${endColor} ${endPercent});
      background-repeat: repeat-x;
    `;
  }
};

// Vertical gradient, from top to bottom
//
// Creates two color stops, start and end, by specifying a color and position for each color stop.
export class GradientY extends Mixin {
  style({$}, [startColor=undefined, endColor=undefined, startPercent="0%", endPercent="100%"]) {
    startColor = startColor ?? $.gray700;
    endColor = endColor ?? $.gray800;
    return css`
      background-image: linear-gradient(to bottom, ${startColor} ${startPercent}, ${endColor} ${endPercent});
      background-repeat: repeat-x;
    `;
  }
};

export class GradientDirectional extends Mixin {
  style({$}, [startColor=undefined, endColor=undefined, deg="45deg"]) {
    startColor = startColor ?? $.gray700;
    endColor = endColor ?? $.gray800;
    return css`
      background-image: linear-gradient(${deg}, ${startColor}, ${endColor});
      background-repeat: repeat-x;
    `;
  }
};

export class GradientXThreeColors extends Mixin {
  style({$}, [startColor=undefined, midColor=undefined, colorStop="50%", endColor=undefined]) {
    startColor = startColor ?? $.blue;
    midColor = midColor ?? $.purple;
    endColor = endColor ?? $.red;
    return css`
      background-image: linear-gradient(to right, ${startColor}, ${midColor} ${colorStop}, ${endColor});
      background-repeat: no-repeat;
    `;
  }
};

export class GradientYThreeColors extends Mixin {
  style({$}, [startColor=undefined, midColor=undefined, colorStop="50%", endColor=undefined]) {
    startColor = startColor ?? $.blue;
    midColor = midColor ?? $.purple;
    endColor = endColor ?? $.red;
    return css`
      background-image: linear-gradient(${startColor}, ${midColor} ${colorStop}, ${endColor});
      background-repeat: no-repeat;
    `;
  }
};

export class GradientRadial extends Mixin {
  style({$}, [innerColor=undefined, outerColor=undefined]) {
    innerColor = innerColor ?? $.gray700;
    outerColor = outerColor ?? $.gray800;
    return css`
      background-image: radial-gradient(circle, ${innerColor}, ${outerColor});
      background-repeat: no-repeat;
    `;
  }
};

export class GradientStriped extends Mixin {
  style({$}, [color=undefined, angle="45deg"]) {
    color = rgba($.white, .15);
    return css`
      background-image: linear-gradient(${angle}, ${color} 25%, transparent 25%, transparent 50%, ${color} 50%, ${color} 75%, transparent 75%, transparent);
    `;
  }
};

